export const PRODUCT_IMAGE_PATH = `${process.env.FILES_URL}/images/products`;
export const CONTENT_IMAGE_PATH = `${process.env.FILES_URL}/images/olevaro-admin`;
export const DOCUMENTS_PATH = `${process.env.FILES_URL}/documents/olevaro-admin`;
export const REVIEW_IMAGES_PATH = `${process.env.FILES_FULL_URL}/review_images`;
